<template>
	<v-responsive :aspect-ratio="1">
		<div class="scene-widget">
			<div class="icons-container">
				<v-icon
					v-for="(icon, key) in icons"
					:key="key"
					:class="{ active: conditionTypes[key] }"
					:size="iconSize"
					v-text="icon"
				/>
			</div>

			<div
				ref="nodeName"
				:class="{ autoscroll: scrollWidth > 0 }"
				:style="tickerStyle"
				class="name"
			>
				{{ node.name }}
			</div>
		</div>
	</v-responsive>
</template>

<script>
export default {
	props: {
		node: { type: Object, required: true },
	},

	data: () => ({
		icons: {
			date: "far fa-calendar-alt",
			time: "far fa-clock",
			sensor: "fas fa-running",
			command: "far fa-lightbulb",
		},
		scrollWidth: 0,
	}),

	computed: {
		conditionTypes() {
			return {
				date: this.node.hasDate,
				time: this.node.hasTime,
				sensor: this.node.hasEvent,
				command: this.node.hasCommand,
			};
		},

		iconSize() {
			let iconSize = "20"; // XS
			if (this.$vuetify.breakpoint.sm) iconSize = "16";
			if (this.$vuetify.breakpoint.md) iconSize = "18";
			if (this.$vuetify.breakpoint.lgAndUp) iconSize = "20";
			return iconSize;
		},

		tickerStyle() {
			return `
				--ticker-length: ${-this.scrollWidth - 4}px;
			`;
			// animation-duration: ${this.scrollWidth / 4}s;
		},
	},

	mounted() {
		window.addEventListener("resize", this.calcScrollWidth);
		this.calcScrollWidth();
	},

	destroyed() {
		window.removeEventListener("resize", this.calcScrollWidth);
	},

	methods: {
		calcScrollWidth() {
			const textWidth = this.$refs.nodeName.offsetWidth;
			const containerWidth = this.$refs.nodeName.parentNode.offsetWidth;
			this.scrollWidth = textWidth - containerWidth;
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .v-responsive__content {
	.scene-widget {
		padding: 0;
		border-radius: 4px;
		border: 1px solid rgba(0, 0, 0, 0.2);

		width: 100%;
		height: 100%;

		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: auto min-content;
		gap: 8px 8px;
		place-items: center center;
		grid-template-areas:
			"icons"
			"name";

		color: var(--v-pale-grey-darken4);
		text-align: center;
		white-space: nowrap;
		overflow: hidden;
	}

	.icons-container {
		padding: 4px 6px 2px 6px;
		display: grid;
		grid-template-columns: repeat(2, min-content);
		gap: 12px;
		grid-area: icons;

		i:not(.active) {
			color: #ccc;
		}

		@media #{map-get($display-breakpoints, 'sm-and-up')} {
			padding: 6px 7px 4px 8px;
			gap: 8px;
		}
		@media #{map-get($display-breakpoints, 'md-and-up')} {
			padding: 8px 9px 8px 10px;
			gap: 10px;
		}
	}

	.autoscroll {
		justify-self: baseline;
		animation: ticker 5s linear infinite;
	}

	.name {
		padding: 0 2px 4px 2px;
		font-size: 0.9em;
		line-height: 1.2em;
		overflow: hidden;
	}

	.active {
		color: var(--v-ocean-lighten2);
	}
}

@keyframes ticker {
	0%,
	20% {
		margin-left: 0;
	}
	80%,
	100% {
		margin-left: var(--ticker-length);
	}
}
</style>
